export const MOBILE_BREAKPOINT = 768;
export const SANTA_MARIA_IBGE_CODE = '4316907';
